import React from "react";

const SvgComponent = props => (
  <svg width={43.343} height={25.562} viewBox="0 0 43.343 25.562" {...props}>
    <path
      d="M35.771 25.562a7.571 7.571 0 0 0 7.57-7.571s.039-7.564-7.92-7.564C33.701 3.34 27.07 2.981 25.21 3.481 23.193 1.474 19.836 0 16.441 0 9.711 0 4.193 5.205 3.697 11.81a7.365 7.365 0 0 0 3.668 13.753l28.406-.001zm-27.767-2.82c-2.752 0-4.781-1.991-4.781-4.567 0-2.104 1.336-3.948 3.424-4.579.248-9.943 8.984-10.451 9.955-10.451 2.885 0 5.748 1.415 7.59 3.51 3.728-1.224 8.83 1.647 8.261 7.201 1.452-.59 2.907-.543 3.323-.543 2.088 0 4.606 1.826 4.606 4.821a4.606 4.606 0 0 1-4.606 4.608H8.004z"
      fill="#83a5b3"
    />
  </svg>
);

export default __webpack_public_path__ + "static/media/03d.85f34bb2.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/weather-icons/03d.svg